module.exports = __webpack_public_path__ + "media/site_templates/www.localconcreters.com.au/images/feature_1-520bebd182752c5e21eed33af2e18280.jpeg";